// @flow
import { Selector } from "../../utils/selectorUtils";
import RiskModel from "../../models/RiskModel";

class LocationRiskSelector extends Selector {}

export default new LocationRiskSelector("locationRisks", new RiskModel());
